export const RealityDefenderLogo = ({ height = 24 }: { height?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 48"
      fill="currentColor"
      height={height}
      aria-hidden="true"
    >
      <mask
        height="48"
        id="mask0_7561_6899"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="42"
        x="0"
        y="0"
      >
        <path d="M41.6 0H0V26.8235C0 38.519 9.31248 48 20.8 48C32.2875 48 41.6 38.519 41.6 26.8235V0Z" />
      </mask>
      <g mask="url(#mask0_7561_6899)">
        <path d="M-44.8699 30.2607H16.7447C17.3812 30.2607 17.9917 30.5136 18.4418 30.9637L21.9127 34.4347H-44.8699V30.2607Z" />
        <path d="M-44.8699 11.4775H16.7447C17.3812 11.4775 17.9917 11.7304 18.4418 12.1805L21.9127 15.6515H-44.8699V11.4775Z" />
        <path d="M-44.8699 2.08594H16.7447C17.3812 2.08594 17.9917 2.33879 18.4418 2.78888L21.9127 6.25985H-44.8699V2.08594Z" />
        <path d="M-44.8699 39.6514H16.7447C17.3812 39.6514 17.9917 39.9042 18.4418 40.3543L21.9127 43.8253H-44.8699V39.6514Z" />
        <path d="M-44.8699 20.8682H16.7447C17.3812 20.8682 17.9917 21.121 18.4418 21.5711L21.9127 25.0421H-44.8699V20.8682Z" />
      </g>
      <mask
        height="48"
        id="mask1_7561_6899"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="42"
        x="0"
        y="0"
      >
        <path d="M41.6 0H0V26.8235C0 38.519 9.31248 48 20.8 48C32.2875 48 41.6 38.519 41.6 26.8235V0Z" />
      </mask>
      <g mask="url(#mask1_7561_6899)">
        <path d="M20.8665 34.4355H87.6491V38.6095H26.0345C25.398 38.6095 24.7875 38.3566 24.3374 37.9065L20.8665 34.4355Z" />
        <path d="M20.8665 15.6523H87.6491V19.8263H26.0345C25.398 19.8263 24.7875 19.5734 24.3374 19.1233L20.8665 15.6523Z" />
        <path d="M20.8665 6.26074H87.6491V10.4347H26.0345C25.398 10.4347 24.7875 10.1818 24.3374 9.73171L20.8665 6.26074Z" />
        <path d="M20.8665 43.8262H87.6491V48.0001H25.0404L20.8665 43.8262Z" />
        <path d="M20.8665 25.0439H87.6491V29.2179H26.0345C25.398 29.2179 24.7875 28.965 24.3374 28.5149L20.8665 25.0439Z" />
      </g>
    </svg>
  );
};
